import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';

import RentPaymentSettingModal from './modal';
import RentPaymentTable from './table';

const useStyles = makeStyles(theme => ({
  container: {
    padding: '56px 32px',
  },
  title: {
    ...theme.typography.h2,
    fontWeight: 'normal',
    color: theme.colors.titleColor,
    marginBottom: 8,
  },
  summary: {
    ...theme.typography.h5,
    fontWeight: 'normal',
    color: theme.colors.captionColor,
    marginBottom: 24,
  },
  button: {
    width: '100%',
    height: 40,
    lineHeight: '40px',
    textAlign: 'center',
    ...theme.typography.body2,
    color: theme.colors.mainGreen6,
    border: `1px dashed ${theme.colors.mainGreen6}`,
    borderRadius: 4,
    marginBottom: 24,
    cursor: 'pointer',
  },
}));

const RentPayment = ({
  paymentPlan,
  getPaymentPlan,
  isMustPayDespositFee,
  properties,
  paymentOnline,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [showSettingModal, setShowSettingModal] = useState(false);
  const installProperty = properties?.find(
    item => item?.node?.id === paymentPlan?.properties?.[0]?.id,
  );

  const { instalments } = paymentPlan ?? {};

  const handleBtnClick = () => {
    setShowSettingModal(true);
  };

  const handleModalCancel = () => {
    setShowSettingModal(false);
  };

  return (
    <div className={classes.container}>
      <h2 className={classes.title}>{t('landlord.payment.long_tail.rent_payment.title')}</h2>
      <p className={classes.summary}>{t('landlord.payment.long_tail.rent_payment.tips')}</p>
      <button className={classes.button} onClick={handleBtnClick}>
        <Choose>
          <When condition={!paymentPlan?.instalments?.length}>
            <PlusOutlined />
            &nbsp;&nbsp;
            {t('landlord.payment.long_tail.add.btn')}
          </When>
          <Otherwise>
            <EditOutlined />
            &nbsp;&nbsp;
            {t('landlord.payment.long_tail.edit.btn')}
          </Otherwise>
        </Choose>
      </button>

      <RentPaymentTable dataSource={instalments} paymentOnline={paymentPlan?.paymentOnline} />
      <If condition={showSettingModal}>
        <RentPaymentSettingModal
          activeModal={showSettingModal}
          paymentPlanId={paymentPlan?.id}
          instalments={instalments}
          getPaymentPlan={getPaymentPlan}
          onClose={handleModalCancel}
          isMustPayDespositFee={isMustPayDespositFee}
          properties={installProperty || {}}
          paymentOnline={paymentOnline}
        />
      </If>
    </div>
  );
};

export default RentPayment;
